export const NOT_STARTED_TEAMS = Object.freeze({
	DESCRIPTION:
		'¿Deseas crear equipos? Al crear equipos podrás asociar múltiples miembros y a todos se les asignará la tarea de supervisión',
});
